/* Verona Tempo — 2026-09-24: homepage swipe rows on phones.
   Every row you can swipe sideways on the homepage (category circles, Shop by category, Best sellers, New in,
   Matching sets, Last pairs, Stores) gets the same small "swipe" hint the first time it comes into view: it glides
   a little to the side and springs back, so people see there is more. Once per row, only on phones, never when the
   visitor has already touched the row, and never with "reduce motion". Nothing else changes. */
(function () {
  'use strict';
  if (window.vtSwipeHint) return;
  window.vtSwipeHint = true;
  var mq = window.matchMedia('(max-width: 767.98px)');
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!mq.matches || calm.matches || !('IntersectionObserver' in window)) return;

  var ROWS = '.vt-bubbles__list, .vt-h10-track, .vt-ni__grid, .vt-stores__cards, .vt-setc--home .vt-setc__grid';
  var DIST = 56;

  function nudge(row) {
    if (row.__vtTouched || row.scrollLeft > 4) return;
    if (row.scrollWidth <= row.clientWidth + 20) return;
    var rtl = getComputedStyle(row).direction === 'rtl';
    var d = rtl ? -DIST : DIST;
    var snap = row.style.scrollSnapType;
    row.style.scrollSnapType = 'none';           // let it glide freely, then settle back
    row.scrollBy({ left: d, behavior: 'smooth' });
    setTimeout(function () {
      if (row.__vtTouched) { row.style.scrollSnapType = snap; return; }
      row.scrollBy({ left: -d, behavior: 'smooth' });
      setTimeout(function () { row.style.scrollSnapType = snap; }, 500);
    }, 520);
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      setTimeout(function () { nudge(e.target); }, 350);
    });
  }, { threshold: 0.7 });

  function watch() {
    document.querySelectorAll(ROWS).forEach(function (row) {
      if (row.__vtSwipe) return;
      row.__vtSwipe = true;
      ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) {
        row.addEventListener(ev, function () { row.__vtTouched = true; }, { passive: true });
      });
      io.observe(row);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  window.addEventListener('load', watch);
})();
